import { i18n, type MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { type ColumnDef } from '@tanstack/react-table'
import { type DocumentsViewerContentFilter } from 'routes/documents/-searchParams'
import { InputType } from 'types'

export const PAGE_SIZE = 50

export const CONTENT_TABS: {
  label: MessageDescriptor
  value: DocumentsViewerContentFilter
}[] = [
  { label: msg`Documents`, value: 'documents' },
  { label: msg`Sensors`, value: 'sensors' },
]

export const PLACEHOLDER_MAP: Record<
  DocumentsViewerContentFilter,
  MessageDescriptor
> = {
  documents: msg`Search documents...`,
  sensors: msg`Search sensors...`,
}

export const DOCUMENT_FILTER_COLUMNS: ColumnDef<Record<string, unknown>>[] = [
  {
    id: 'docType',
    header: () => i18n._(msg`Type`),
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
  {
    id: 'vendor',
    header: () => i18n._(msg`Vendor`),
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
  {
    id: 'system',
    header: () => i18n._(msg`System`),
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
]
